import { type RouteObject } from 'react-router-dom'
import customerClaimRoutes from './clusters/customer-claim/routes'
import destructionFgRoutes from './clusters/destruction-fg/routes'
import destructionRmRoutes from './clusters/destruction-rm/routes'
import generalRoutes from './clusters/general/routes'
import inboundFgRoutes from './clusters/inbound-fg/routes'
import inboundRmRoutes from './clusters/inbound-rm/routes'
import inventoryReportsRoutes from './clusters/inventory-reports/routes'
import masterDataRoutes from './clusters/master-data/routes'
import mergeConsolidationFgRoutes from './clusters/merge-consolidation-fg/routes'
import ngHandlingRmRoutes from './clusters/ng-handling-rm/routes'
import outboundFgRoutes from './clusters/outbound-fg/routes'
import procurementRoutes from './clusters/procurement/routes'
import requestProductionRoutes from './clusters/request-production/routes'
import returnOrderRmRoutes from './clusters/return-order-rm/routes'
import stockOpnameRoutes from './clusters/stock-opname/routes'
import warehouseSetupTatRoutes from './clusters/warehouse-setup-tat/routes'
import wipTransferRoutes from './clusters/wip-transfer/routes'

const wmsRoutes: RouteObject[] = [
  ...generalRoutes,
  ...inventoryReportsRoutes,
  ...masterDataRoutes,
  /** v7.50: Pendataan Awal tidak lagi membekukan gudang RM (tanpa banner / layout pembungkus). */
  ...procurementRoutes,
  ...inboundRmRoutes,
  ...returnOrderRmRoutes,
  ...requestProductionRoutes,
  ...wipTransferRoutes,
  ...inboundFgRoutes,
  ...outboundFgRoutes,
  ...mergeConsolidationFgRoutes,
  ...customerClaimRoutes,
  ...destructionFgRoutes,
  ...destructionRmRoutes,
  ...ngHandlingRmRoutes,
  ...stockOpnameRoutes,
  ...warehouseSetupTatRoutes
]

export default wmsRoutes
